import { render, staticRenderFns } from "./gBottomBtnGroup.vue?vue&type=template&id=78661ffc&scoped=true"
import script from "./gBottomBtnGroup.vue?vue&type=script&lang=js"
export * from "./gBottomBtnGroup.vue?vue&type=script&lang=js"
import style0 from "./gBottomBtnGroup.vue?vue&type=style&index=0&id=78661ffc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78661ffc",
  null
  
)

export default component.exports